import { Link } from 'react-router-dom';
import type { UserPublicProfile } from '@/types/domain';
import { Button } from '@/components/ui/Button';
import { Avatar } from '@/components/ui/Avatar';
import { useToggleSubscription, useUserProfile, useMe } from '@/hooks/useUser';
import { haptic } from '@/lib/telegram';
import styles from './SellerCard.module.css';

interface Props {
  seller: UserPublicProfile;
}

export const SellerCard = ({ seller }: Props) => {
  // Подтягиваем актуальный профиль (с флагом is_following)
  const { data: fullProfile } = useUserProfile(seller.id);
  const { data: me } = useMe();
  const toggle = useToggleSubscription();
  const isFollowing = fullProfile?.is_following ?? false;
  const isMe = me?.id === seller.id;

  const handleFollow = () => {
    haptic.medium();
    toggle.mutate(seller.id);
  };

  return (
    <div className={styles.card}>
      <Link to={`/user/${seller.id}`} className={styles.main}>
        <Avatar src={seller.avatar_url} name={seller.display_name} size="md" />
        <div className={styles.info}>
          <p className={styles.name}>{seller.display_name}</p>
          <div className={styles.meta}>
            <span className={styles.rating}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
              {seller.rating.toFixed(1)}
            </span>
            <span className={styles.sep}>·</span>
            <span className={styles.sales}>{seller.auctions_sold} продаж</span>
            <span className={styles.sep}>·</span>
            <span className={styles.reviews}>{seller.rating_count} отзывов</span>
          </div>
        </div>
      </Link>

      {!isMe && (
        <Button
          variant="secondary"
          size="sm"
          onClick={handleFollow}
          loading={toggle.isPending}
          className={isFollowing ? styles.followingBtn : ''}
        >
          {isFollowing ? 'В подписках' : 'Подписаться'}
        </Button>
      )}
    </div>
  );
};